export function locationMatches(location: string, impressionPage: string | undefined): boolean {
  if (!impressionPage) return false
  const impressionPageRegex = new RegExp(impressionPage)
  return impressionPageRegex.test(location)
}
